﻿export function decodeHTML(value: string): string {
    return value.replace(/&#(\d+);/g, (match, dec) => {
        return String.fromCharCode(dec);
    });
}
